import React from "react";
import styled from "styled-components";
import { LinearProgress, Theme } from "@mui/material";
import { withStyles } from "@mui/styles";
import { RavenLogoSVG } from "../Logo/RavenLogoSVG";
import { GradiantScreen } from "../GradiantScreen/GradiantScreen";
import { getWhitelabelConfig } from "../../utils";

export interface LoadingScreenProps {
  loadingDescription?: string;
  progress?: number;
  buffer?: number;
  disableProgress?: boolean;
}

export const LoadingScreen = ({
  loadingDescription,
  progress,
  disableProgress = false,
}: LoadingScreenProps): React.JSX.Element => {
  progress = progress || 0;
  const whitelabelConfig = getWhitelabelConfig();
  return (
    <GradiantScreen>
      <StyledLoading>
        <div className="fill-space"></div>
        <div className="loading-header">
          {whitelabelConfig?.logoUrl ? (
            <img
              alt="company-logo"
              src={whitelabelConfig.logoUrl}
              style={{
                height: (whitelabelConfig.logoHeight ?? 32) + "px",
                width: whitelabelConfig.logoWidth ? whitelabelConfig.logoWidth + "px" : "auto",
              }}
            />
          ) : (
            <RavenLogoSVG logoWidth={"25vh"} />
          )}
        </div>
        {loadingDescription && (
          <div className="desc">
            <div data-testid="load-desc" className="load-desc">
              {loadingDescription}
            </div>
          </div>
        )}
        <div className="fill-space"></div>
        <LinearProgressRow>
          {!disableProgress && (
            <StyledLinearProgress className="bar" variant="determinate" value={progress} />
          )}
        </LinearProgressRow>
      </StyledLoading>
    </GradiantScreen>
  );
};

const LinearProgressRow = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 5%;
  line-height: 14vh;
  width: 100%;

  .bar {
    position: "relative";
    overflow: "hidden";
    width: 90%;
  }

  .barColor {
    color: white;
  }
`;

const FALLBACK_GREY = "rgb(100, 100, 100)";

const StyledLinearProgress = withStyles((theme: Theme) => {
  const backgroundColor =
    theme.palette?.grey?.[theme.palette?.mode && theme.palette.mode === "light" ? 700 : 900] || FALLBACK_GREY;
  return {
    root: {
      height: 4,
      borderRadius: 0.5,
    },
    colorPrimary: {
      backgroundColor,
    },
    bar: {
      borderRadius: 0.75,
      backgroundColor: "white",
    },
  };
})(LinearProgress);

const StyledLoading = styled.div`
  width: 100%;

  .loading-header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 10vh;
  }

  .fill-space {
    padding-top: 40vh;
    flex: 1 1 auto;
  }

  .desc {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 7vh;
    font-size: 4vh;
    font-family: "Helvetica Neue";

    .loading-desc {
      font-weight: normal;
      text-align: center;
      justify-content: center;
    }
  }
`;
